<template>
  <div>
    <v-app-bar app clipped-left elevate-on-scroll dense color="primary" dark>
      <v-icon class="mr-3" x-large>mdi-auto-fix</v-icon>
      <h1>ProWizard</h1>
      <v-spacer />
      <v-btn text dark large class="primary ma-2" @click="clearToken"
        ><v-icon>mdi-logout</v-icon>Выйти
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      permanent
      app
      clipped
      width="200px"
      max-width="35%"
      height="100%"
      expand-on-hover
      absolute
      mini-variant
      bottom
    >
      <slot name="nav" />
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>
    <v-dialog max-width="40%" v-model="dialog">
      <v-card>
        <v-card-title>
          {{ message.title }}
        </v-card-title>
        <v-card-text :class="message.isError ? `red--text` : ''">
          {{ message.text }}
        </v-card-text>
        <v-card-actions>
          <v-btn block color="primary" @click="dialog = false"> ОК </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
  }),
  watch: {
    message(newMessage) {
      if (newMessage.text != "") {
        this.dialog = true;
      }
    },
  },
  methods: {
    ...mapActions(["clearToken"]),
  },
  computed: {
    ...mapGetters(["message"]),
  },
};
</script>

<style>
</style>
